/**
 * Curriculum v1.
 *
 * Cada sesión registrada guarda la versión con la que se ejecutó. Si más
 * adelante cambia el programa, los registros anteriores conservan su versión.
 * No se construye un resolutor de versiones históricas: la vista muestra una
 * nota cuando un registro apunta a otra versión.
 */

import type { Curriculum } from '../tipos.js';
import { BLOQUES_ENFASIS } from './enfasis.js';
import { HERRAMIENTAS } from './herramientas.js';
import { PROMPTS } from './prompts.js';
import { SESIONES } from './sesiones/index.js';

export const VERSION_CURRICULUM = 'v1';

export const CURRICULUM_V1: Curriculum = {
  version: VERSION_CURRICULUM,
  sesiones: SESIONES,
  prompts: PROMPTS,
  herramientas: HERRAMIENTAS,
  enfasis: BLOQUES_ENFASIS,
};
